import React, { useEffect, useState } from 'react';
import { Button, Flex } from 'antd';
import { useAppStore } from '../../common/store';
import { getAnalyticsIdForFooter } from '../../common/tracking/analyticsUtils';
import { t } from '../../utils';
import { navigationEventManager } from '../../utils/navigationEventManager';

const stepperMap = {
	0: 'start',
	1: 'prepare',
	2: 'review',
};

const buttonTextMap = {
	0: 'startPage.footerButton',
	1: 'preparePage.footerButton',
	2: 'reviewPage.footerButton',
};

const Footer = () => {
	const { templateMetadata, documentTemplate } = useAppStore(state => ({
		templateMetadata: state.templateMetadata,
		documentTemplate: state.documentTemplate,
	}));
	const [result, setResults] = useState(null);

	const step = stepperMap[templateMetadata?.currentStep] || null;

	const getButtonText = () => {
		return t(buttonTextMap[templateMetadata?.currentStep]);
	};

	const mapSize = navigationEventManager?.getEventManager()?.size;
	useEffect(() => {
		if (step) {
			const r = navigationEventManager.getEventManager().get(step);
			setResults(r);
		}
	}, [step, mapSize]);

	return (
		<>
			{documentTemplate && (
				<Flex justify={templateMetadata?.currentStep === 0 ? 'end' : 'space-between'}>
					{result && (
						<>
							{templateMetadata?.currentStep !== 0 && (
								<FooterBackButton
									onClick={result.onPrevious}
									buttonText={t('footer.previousButton')}
									currentStep={templateMetadata?.currentStep}
								/>
							)}
							<FooterNextButton
								onClick={result.onNext}
								buttonText={t(getButtonText())}
								currentStep={templateMetadata?.currentStep}
							/>
						</>
					)}
				</Flex>
			)}
		</>
	);
};

const FooterBackButton = ({ onClick, buttonText, currentStep }) => {
	return (
		<Button
			onClick={onClick}
			data-analytics-id={getAnalyticsIdForFooter(currentStep, 'back')}
			data-testid="docgen-footer-back-button"
		>
			{buttonText}
		</Button>
	);
};

const FooterNextButton = ({ onClick, buttonText, currentStep }) => {
	const isLoading = useAppStore(state => state.isLoading);

	return (
		<Button
			type="primary"
			onClick={onClick}
			disabled={isLoading}
			loading={isLoading}
			data-analytics-id={getAnalyticsIdForFooter(currentStep, 'next')}
			data-testid="docgen-footer-next-button"
		>
			{buttonText}
		</Button>
	);
};

export default Footer;
